import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useFormik } from "formik";
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import "./index.css";
import { useNavigate } from "react-router-dom";
import ToastMessage from "../../utils/ToastMessage";
import { LoginFormSchema } from "../../utils/validation";
import ButtonComponent from "../../components/LoginBtn/Button";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import MuiPhoneNumber from "mui-phone-number";
// import MuiPhoneNumber from '@mui/icons-material/PhoneNumber';

import {
  OtpverifyApi,
  loginApi,
  postApiCall,
  resendotpApi,
} from "../../API/baseUrl";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button } from "bootstrap";
import PhoneInput from "react-phone-input-2";

const initialValues = {
  mobile: "",
  dial_code: "91",
  otp: "",
};

const Login = ({
  handleafterloginaddtocart,
  wishlist,
  handlelike,
  setShowloginpopup,
  showloginpopup,
  reload,
  setReload,
  refresh,
  setRefresh,
  setMobilenumber,
  setCartTotal,
  productId,
  setCartcount,
  handlelikeafterLogin,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [useridval, setUseridval] = useState("");
  const [showotp, setShowotp] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [timeLeft, setTimeLeft] = useState(120);
  const [userid, setUserid] = useState("");
  console.log(productId, "productId9999999");
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: LoginFormSchema,
    onSubmit: () => submitForm(),
  });
  useEffect(() => {
    console.log(errors, values, "llll");
  }, [values, errors]);
  const handleprofilePageclose = () => {
    setShowloginpopup(false);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit2 = (e) => {

    e.preventDefault();
    handleSubmit();
    console.log("error", errors);
    console.log("values", values);
  };

  const handleNumberChange = async () => {
    const apiValue = {
      mobile: values.mobile.trim(),
      dial_code: values.dial_code,
    };
    try {
      const result = await postApiCall(
        `${resendotpApi}/${useridval}`,
        apiValue
      );
      if (result.data.status) {
        ToastMessage("success", result.data.message);

        setTimeLeft(120);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------------------api call---------------------------------------------
  const submitForm = async () => {
  
    const apiValue = {
      mobile: values.mobile.trim(),
      dial_code: values.dial_code,
    };
    try {
      setLoading(true);
      const result = await postApiCall(loginApi, apiValue);

      if (result.data.status) {
        localStorage.setItem("userId", result.data.data.userId);
        setUseridval(result.data.data.userId);
        setLoading(false);
        setShowotp(true);
        setReload(!reload);

        ToastMessage("success", result.data.message);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const gototerms = () => {
    navigate("/terms");
    setShowloginpopup(false);
  };

  const OtpVerify = async () => {
    const otpValue = {
      mobile: values.mobile.trim(),
      dial_code: values.dial_code,
      otp: values.otp,
    };
    try {
      setLoading(true);
      const result = await postApiCall(OtpverifyApi, otpValue);

      if (result.data.status) {
        localStorage.setItem("user_id", result.data.userId);
        localStorage.setItem("mobile", result.data.mobile);
        setUserid(result.data.userId);
        console.log(userid, "useriduseriduseriduseriduserid");
        if (result?.data?.name) {
          localStorage.setItem("name", result.data.name);
        } else {
          localStorage.setItem("name", "");
        }

        localStorage.setItem("refresh_token", result.data.refresh_token);
        localStorage.setItem("access_token", result.data.token);
        setLoading(false);
        ToastMessage("success", result.data.message);
        setShowloginpopup(false);

        setReload(!reload);

        if (handleafterloginaddtocart) {
          handleafterloginaddtocart(result.data.userId);
        } else if (handlelikeafterLogin) {
          handlelikeafterLogin(productId, result.data.userId);
        }
      } else {
        ToastMessage("error", result.data.message);
        if (
          result.data.message ===
          "Maximum verification attempts reached. Please contact support."
        ) {
          setShowotp(false);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  // ----------------------------------------------api call-----------------------------------------------
  return (
    <Modal
      open={showloginpopup}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      sx={{ fontFamily: "'Lato', sans-serif" }}
    >
      <Box
        sx={{
          my: { xs: "30%", sm: "10%", md: "10%" },
          mx: "auto",
          width: { xs: "90%", sm: 500 },
          bgcolor: "var(--white-color)",
          p: 4,
          borderRadius: 3,
          boxShadow: 24,
        }}
      >
        {showotp ? (
          <Box>
            <Grid container justifyContent="flex-end">
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleprofilePageclose}
              />
            </Grid>

            <Typography
              variant="h5"
              fontWeight={600}
              mb={1}
              color="var(--heading-color)"
            >
              OTP Verification
            </Typography>
            <Typography variant="body2" color="var(--dark-gray-color)" mb={3}>
              Please enter the OTP sent to your number.
            </Typography>

            <FormControl variant="outlined" fullWidth sx={{ mt: 2 }}>
              <InputLabel required>Enter OTP</InputLabel>
              <OutlinedInput
                name="otp"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.otp}
                type={showPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Enter OTP"
              />
              {errors.password && touched.password && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {errors.password}
                </Typography>
              )}
            </FormControl>

            <Grid sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
              <button
                type="submit"
                className="loginbtn"
                onClick={OtpVerify}
                style={{
                  backgroundColor: "var(--primary-color)",
                  color: "#fff",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#a76e3b")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#bc8246")
                }
              >
                Verify
              </button>
            </Grid>

            <Typography align="center" mt={4} sx={{ fontSize: "0.9rem" }}>
              {minutes === 0 && seconds === 0
                ? ""
                : `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`}
              <br />
              <button
                type="button"
                disabled={minutes !== 0 || seconds !== 0}
                onClick={handleNumberChange}
                style={{
                  color: "var(--primary-color)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                  textDecoration: "underline",
                  marginTop: "10px",
                }}
              >
                Resend OTP
              </button>
            </Typography>
          </Box>
        ) : (
          <Box component="form" noValidate onSubmit={handleSubmit2}>
            <Grid container justifyContent="flex-end">
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleprofilePageclose}
              />
            </Grid>

            <Typography
              variant="h5"
              fontWeight={600}
              mb={2}
              color="var(--heading-color)"
            >
              Login
            </Typography>

            <Typography variant="body2" color="var(--dark-gray-color)" mb={3}>
              Get access to your Orders, Wishlist and Recommendations
            </Typography>

            <Typography variant="subtitle1" fontWeight={500} mb={1}>
              Mobile Number
            </Typography>
            <TextField
              fullWidth
              name="mobile"
              variant="outlined"
              placeholder="Enter phone number"
              onChange={handleChange}
              value={values.mobile}
              error={touched.mobile && Boolean(errors.mobile)}
              helperText={touched.mobile && errors.mobile}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+91</InputAdornment>
                ),
              }}
            />

            <Typography variant="body2" color="var(--dark-gray-color)" mt={2}>
              By continuing, you agree to TreasureBox’s{" "}
              <span
                onClick={gototerms}
                style={{
                  color: "var(--primary-color)",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                Terms & Conditions
              </span>
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
              <button
                type="submit"
                className="loginbtn"
                style={{
                  backgroundColor: "var(--primary-color)",
                  color: "#fff",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#a76e3b")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#bc8246")
                }
              >
                Request OTP
              </button>
            </Grid>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default Login;
